module.exports = __webpack_public_path__ + "static/media/desert-dark.5b32b51e.svg";